import * as React from 'react';

import TablePagination from '@material-ui/core/TablePagination';

import Article from '../Article/Article';
import { IProps } from './interfaces';

import styles from './Hashtags.module.styl';

const MIN_PAGINATION_LIMIT = 10;

const Hashtags = (props: IProps) => {
  const {
    data: { articles, pagination },
    handleChangePage,
    handleChangeRowsPerPage,
  } = props;

  return (
    <div className={styles.root}>
      {articles.map((article: any) => (
        <div key={article.id} className={styles.wrapper}>
          <Article data={{ article }} preview={true} />
        </div>
      ))}
      {pagination && pagination.total > MIN_PAGINATION_LIMIT && (
        <TablePagination
          component="div"
          count={pagination.total}
          rowsPerPage={pagination.limit}
          page={pagination.page - 1}
          backIconButtonProps={{
            'aria-label': 'Previous Page',
          }}
          nextIconButtonProps={{
            'aria-label': 'Next Page',
          }}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        />
      )}
    </div>
  );
};

export default Hashtags;
